export enum UpstreamTransactionType {
    OVERWRITE, DELETE
}
